"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_MAX_AGE_IN_YEARS = void 0;
exports.COOKIE_MAX_AGE_IN_YEARS = 5;
